// לא לחישוב (not counted) has no row yet. It waits on a product decision
// between intermediary, a new role key, and a member flag.
export const TREE_MEMBER_ROLES = [
  { key: 'supplier', label: 'ראשי' },
  { key: 'consumer', label: 'משני' },
] as const

export type TreeMemberRole = (typeof TREE_MEMBER_ROLES)[number]['key']

export const DEFAULT_TREE_MEMBER_ROLE: TreeMemberRole = 'consumer'

export const treeMemberRoleLabel = (key: unknown): string => {
  if (typeof key !== 'string' || key.trim() === '') return '-'
  return TREE_MEMBER_ROLES.find(role => role.key === key)?.label ?? key
}
